import "./GridRow14.css";
const GridRow14 = () => {
  return (
    <>
      <div id="GridBox14Id" className="GridBox14">
        <div className="Fourteen1">
          <h3>Explore our furniture & home furnishing range</h3>{" "}
          <h4>IKEA is a global leader in life at home.</h4>
          <p>
            Whether you just moved into a new home or looking to revamp your
            current one, we at IKEA are here to inspire you with affordable home
            furniture solutions, there is a piece of furniture to every corner
            of your home. Create a home that is perfect for you.
          </p>{" "}
          <p>
            Shopping at IKEA is a bit different and exciting compared to your
            shopping at an everyday retail. It is about experiencing solutions
            first hand and getting to know ideas and inspirations that can fit
            perfectly into your home. That’s why, we offer more than 7500
            products, solutions at our store along with home furnishing ideas
            and services for you to explore.{" "}
          </p>{" "}
          <p>
            When you visit IKEA store, make yourself at home in our many room
            settings in the store. Squeeze the upholsteries, feel the oriental
            rugs, try the sofa beds and open the cabinets to feel the quality.
            On the price tag, you’ll find all you need to know about a product,
            including where in the store you can pick it up.
          </p>
          <p>
            {" "}
            Since most IKEA furniture is flat-packed, they are quite easy to
            bring home when you buy from the store.
          </p>
        </div>
        <div className="Fourteen2">
          <a href="#"> Sofas</a>|<a href="#"> Beds</a>|<a href="#"> Dining</a>|
          <a href="#"> Tv units</a>|<a href="#"> Mattresses</a>|
          <a href="#"> Seating</a>|<a href="#"> Coffee tables</a>|
          <a href="#"> Wardrobes</a>| <a href="#"> Storage</a>|{" "}
          <a href="#"> Bookshelves</a>|<a href="#"> Shoe racks</a>|
          <a href="#"> Decor</a>|<a href="#"> Bathroom</a>|
          <a href="#"> Textiles</a>|<a href="#"> Pots & plants</a>|{" "}
          <a href="#"> Home electronics</a>|<a href="#"> Home improvement</a>|
          <a href="#"> Lighting</a>|<a href="#"> Mattresses</a>|
        </div>
      </div>
    </>
  );
};
export default GridRow14;
